import axios from "axios";

// Configuration
const BASE_URL = "https://erp.physiotattva.com";
const CONSUMER_KEY = "9fVv3Xt4iK4GL4duoVsiDOs3B25WyME2";
const CONSUMER_SECRET = "S4TKFR2O8EVjz6lptCCidW0zDATUfFWi";
const ACCESS_TOKEN = "HOJgII2inurZmkkjgPZPedFq0scLEd20";
const ACCESS_TOKEN_SECRET = "0Dr7FE8IVQdaiAYc1pmRM8Y60Cj5worn";

// Create axios instance
const api = axios.create({
  baseURL: BASE_URL,
});

// Simple OAuth 1.0a header generator
const generateOAuthHeader = (method, url) => {
  const timestamp = Math.floor(Date.now() / 1000);
  const nonce = Math.random().toString(36).substring(2);

  const parameters = {
    oauth_consumer_key: CONSUMER_KEY,
    oauth_token: ACCESS_TOKEN,
    oauth_signature_method: "PLAINTEXT",
    oauth_timestamp: timestamp,
    oauth_nonce: nonce,
    oauth_version: "1.0",
  };

  const signature = `${encodeURIComponent(
    CONSUMER_SECRET
  )}&${encodeURIComponent(ACCESS_TOKEN_SECRET)}`;
  parameters.oauth_signature = signature;

  const headerParts = Object.entries(parameters).map(
    ([key, value]) =>
      `${encodeURIComponent(key)}="${encodeURIComponent(value)}"`
  );

  return `OAuth ${headerParts.join(", ")}`;
};

// Request interceptor for OAuth 1.0a header
api.interceptors.request.use((config) => {
  const method = config.method.toUpperCase();
  const url = `${BASE_URL}${config.url}`;

  config.headers["Authorization"] = generateOAuthHeader(method, url);
  return config;
});

// Patient API service
const PatientService = {
  getPatients: async (userId = 1) => {
    try {
      const response = await api.get(
        "/restapi/1.0/object/oeh.medical.patient",
        {
          params: {
            domain: [],
            fields: '["name", "id","identification_code"]',
            user_id: userId,
          },
        }
      );
      return response.data["oeh.medical.patient"] || [];
    } catch (error) {
      console.error("Error fetching patients:", error);
      throw error;
    }
  },

  fetchCampusList: async () => {
    try {
      const response = await api.get("/restapi/1.0/object/res.campus", {
        params: {
          domain: "[]",
          fields: JSON.stringify(["name", "id"]),
        },
      });
      return response.data["res.campus"];
    } catch (error) {
      console.error("Error fetching campus list:", error);
      throw error;
    }
  },

  getDoctors: async (userId = 1) => {
    try {
      const response = await api.get("/get/doctors", {
        params: {
          consultation_type_id: 5,
          user_id: userId,
        },
      });
      return response.data || [];
    } catch (error) {
      console.error("Error fetching patients:", error);
      throw error;
    }
  },

  fetchPhysiotherapists: async () => {
    try {
      const response = await api.get("/restapi/1.0/object/hr.employee", {
        params: {
          domain: [
            ('related_doctor_id.doctor_treating', '=', true),
            ('related_doctor_id.active_doctor', '=', true),
            ('related_doctor_id.waiting_approval', '=', false),
            ('related_doctor_id.company_type', '=', 'person') ,
          ]
          ,
          fields: JSON.stringify([
            "id",
            "name",
            "team_role",
            "related_doctor_id",
            "campus_location",
            "employee_code",
            "name_related",
            "work_email",
            "mobile_phone",
            "work_phone",
            "job_id",
            "department_id",
          ]),
        },
      });
      return response.data["hr.employee"];
    } catch (error) {
      console.error("Error fetching physiotherapists:", error);
      throw error;
    }
  },

  // Add more methods here as needed, e.g., getPatientById, createPatient, updatePatient, etc.
};

export default PatientService;
